var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListMode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.46 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.88,11.54H.58a.58.58,0,0,0-.58.57v2.31A.58.58,0,0,0,.58,15h2.3a.58.58,0,0,0,.58-.58V12.11A.58.58,0,0,0,2.88,11.54ZM2.88,0H.58A.58.58,0,0,0,0,.58V2.89a.58.58,0,0,0,.58.57h2.3a.58.58,0,0,0,.58-.57h0V.58A.58.58,0,0,0,2.88,0Zm0,5.77H.58A.58.58,0,0,0,0,6.35v2.3a.58.58,0,0,0,.58.58h2.3a.58.58,0,0,0,.58-.58V6.35A.58.58,0,0,0,2.88,5.77Zm15,6.34H6.35a.58.58,0,0,0-.58.58v1.16a.58.58,0,0,0,.58.57H17.89a.58.58,0,0,0,.57-.57V12.69A.58.58,0,0,0,17.89,12.11Zm0-11.53H6.35a.58.58,0,0,0-.58.57h0V2.31a.58.58,0,0,0,.58.58H17.89a.58.58,0,0,0,.57-.58V1.15A.58.58,0,0,0,17.89.58Zm0,5.77H6.35a.57.57,0,0,0-.58.57V8.08a.57.57,0,0,0,.58.57H17.89a.57.57,0,0,0,.57-.57V6.93a.57.57,0,0,0-.57-.58Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListMode);
export default __webpack_public_path__ + "static/media/list-mode.a822b324.svg";
export { ForwardRef as ReactComponent };